export default "__VITE_ASSET__BrbUOJG3__"